<template>
  <SoAdminPage
    title="Email Templates"
    subtitle="Manage the HTML email templates used for customer communications"
  >
    <template #headerRight>
      <div class="d-flex align-center ga-2">
        <SoButton
          type="secondary"
          title="Headline Image"
          prepend-icon="file-image"
          large
          data-testid="email-headline-image"
          :to="{ name: RouteNames.AdminEmailHeadlineImage }"
        />
        <SoButton
          type="success"
          title="Create Template"
          prepend-icon="plus"
          large
          data-testid="create-email-template"
          :to="{ name: RouteNames.AdminEmailTemplatesCreate }"
        />
      </div>
    </template>
    <AdminEmailTemplatesListTable />
  </SoAdminPage>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { RouteNames } from "@/types/router"
  import SoAdminPage from "@/components/templates/SoAdminPage.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import AdminEmailTemplatesListTable from "./components/AdminEmailTemplatesListTable.vue"

  export default defineComponent({
    components: {
      SoAdminPage,
      SoButton,
      AdminEmailTemplatesListTable,
    },
    data() {
      return {
        RouteNames,
      }
    },
  })
</script>
